module.exports = __webpack_public_path__ + "img/xny.f34dab0.png";